<template>
    <div class="radio">
        <div class="radioBox">
            <div class="itemRadio" v-for="(item,index) in list" :key="index" :class="{'active' : index === type}" @click="change(index)">
                <i v-if="item.icon" :class="item.icon"></i>
                <span v-else>{{ item.val }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        list:{
            type: Array,
            default: []
        },
        type:{
            type: Number,
            default: 0
        }
    },
    data() {
        return {};
    },
    methods:{
        change(type){
            this.$emit('change',type)
        }
    }
};
</script>

<style scoped lang="scss">

.radio{
    margin: 10px 0;
}
.radioBox {
    border-radius: 4px 0 0 4px;
    display: flex;
    align-items: center;
    font-size: 18px;
    .itemRadio{
        width: 50px;
        height: 36px;
        color: #000;
        border: 1px solid #dcdfe6;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all .3s;
    }
    .active{
        border: 1px solid #409eff;
        background-color: #409eff;
        color: #fff;
    }
}
</style>